"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_PARTICIPANTS_SUCCEEDED = void 0;
const service_1 = __importDefault(require("../../services/chats/service"));
const constants_1 = require("../../constants");
const Stopwatch_1 = __importDefault(require("../../utils/Stopwatch"));
const modalSpinner_1 = require("../app/modalSpinner");
const Alert_1 = require("../../components/modals/Alert");
const setFunctions = __importStar(require("../../utils/setFunctions"));
exports.ADD_PARTICIPANTS_SUCCEEDED = "ADD_PARTICIPANTS_SUCCEEDED";
function default_1(chat, userIds) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        if (chat.kind === constants_1.UNCONFIRMED_GROUP_CHAT)
            return;
        dispatch(modalSpinner_1.startSpinning());
        const timer = Stopwatch_1.default.startNew();
        const response = yield service_1.default.addParticipants(chat.chatId, userIds);
        if (response.kind === "success" || response.kind === "partialSuccess") {
            let usersAdded = userIds;
            if (response.kind === "partialSuccess") {
                setFunctions.exceptWith(usersAdded, response.blocked);
                let text = "You can't add users if you are blocking them or they are blocking you";
                let title = "User not added";
                if (userIds.length > 1) {
                    if (response.countAdded == 0) {
                        title = "No users added";
                    }
                    else {
                        title = `Only ${response.countAdded} users added`;
                    }
                }
                Alert_1.alertDialog({ title, text });
            }
            if (response.countAdded > 0) {
                dispatch({
                    type: exports.ADD_PARTICIPANTS_SUCCEEDED,
                    payload: {
                        chatId: chat.chatId,
                        users: usersAdded,
                        durationMs: timer.getElapsedMs()
                    }
                });
            }
        }
        dispatch(modalSpinner_1.stopSpinning());
    });
}
exports.default = default_1;
